import React from 'react';

import '../../styles/_dark-theme.scss';

const Dark = () => <></>;

export default Dark;
